export const CURRENT_ROLE_OPTIONS = [
  {
    id: 1,
    key: 'currentRole.itManager',
    name: 'IT Manager',
  },
  {
    id: 2,
    key: 'currentRole.productionManager',
    name: 'Quản lý sản xuất',
  },
  {
    id: 3,
    key: 'currentRole.warehouseManager',
    name: 'Quản lý kho',
  },
  {
    id: 4,
    key: 'currentRole.generalManager',
    name: 'Quản đốc',
  },
  {
    id: 5,
    key: 'currentRole.productionMaintainance',
    name: 'Bảo trì sản xuất',
  },
  {
    id: 6,
    key: 'currentRole.other',
    name: 'Khác',
  },
]

export const WORK_TYPE_OPTIONS = [
  {
    id: 1,
    key: 'bussinessType.furniture',
    name: 'Gỗ & nội thất',
  },
  {
    id: 2,
    key: 'bussinessType.plastic',
    name: 'Nhựa & bao bì',
  },
  {
    id: 3,
    key: 'bussinessType.textile',
    name: 'Dệt may & da giày',
  },
  {
    id: 4,
    key: 'bussinessType.accessary',
    name: 'Linh kiện phụ tùng',
  },
  {
    id: 5,
    key: 'bussinessType.chemical',
    name: 'Hoá chất',
  },
  {
    id: 6,
    key: 'bussinessType.buildingMaterial',
    name: 'Vật liệu xây dựng',
  },
  {
    id: 7,
    key: 'bussinessType.metal',
    name: 'Kim loại',
  },
  {
    id: 8,
    key: 'bussinessType.mechanical',
    name: 'Máy móc, thiết bị, cơ khí',
  },
  {
    id: 9,
    key: 'bussinessType.medicalEquipment',
    name: 'Thiết bị y tế',
  },
  {
    id: 10,
    key: 'bussinessType.medicine',
    name: 'Dược phẩm',
  },
  {
    id: 11,
    key: 'bussinessType.electricity',
    name: 'Điện',
  },
  {
    id: 12,
    key: 'bussinessType.agriculture',
    name: 'Nông lâm thủy sản',
  },
  {
    id: 13,
    key: 'bussinessType.retail',
    name: 'Bán lẻ',
  },
  {
    id: 14,
    key: 'bussinessType.logistic',
    name: 'Logistics',
  },
  {
    id: 15,
    key: 'bussinessType.other',
    name: 'Khác',
  },
]

export const INTEREST_FEATURE_OPTIONS = [
  {
    id: 1,
    key: 'interestFeature.productionManagement',
    name: 'Quản lý sản xuất',
  },
  {
    id: 2,
    key: 'interestFeature.deviceManagement',
    name: 'Quản lý và bảo trì thiết bị',
  },
  {
    id: 3,
    key: 'interestFeature.warehouseStockManagement',
    name: 'Quản lý hàng tồn kho',
  },
  {
    id: 4,
    key: 'interestFeature.productionQuality',
    name: 'Quản lý chất lượng sản xuất',
  },
  {
    id: 5,
    key: 'interestFeature.seekOrigin',
    name: 'Truy xuất nguồn gốc',
  },
  {
    id: 6,
    key: 'interestFeature.devicePerformance',
    name: 'Hiệu suất thiết bị, máy móc',
  },
  {
    id: 7,
    key: 'interestFeature.productionReport',
    name: 'Báo cáo sản xuất',
  },
  {
    id: 8,
    key: 'interestFeature.other',
    name: 'Khác',
  },
]

export const EXPERIMENTAL_PURPOSE = [
  {
    id: 3,
    key: 'experimentalPurpose.consultation',
    name: 'Nhận demo và tư vấn',
  },
  {
    id: 1,
    key: 'experimentalPurpose.companySolution',
    name: 'Ứng dụng giải pháp cho công ty',
  },
  {
    id: 2,
    key: 'experimentalPurpose.consultAndLearn',
    name: 'Tham khảo, học hỏi',
  },
  {
    id: 4,
    key: 'experimentalPurpose.other',
    name: 'Khác',
  },
]

export const VIETNAM_PROVINCES = [
  'An Giang',
  'Bà Rịa - Vũng Tàu',
  'Bạc Liêu',
  'Bắc Giang',
  'Bắc Kạn',
  'Bắc Ninh',
  'Bến Tre',
  'Bình Dương',
  'Bình Định',
  'Bình Phước',
  'Bình Thuận',
  'Cà Mau',
  'Cao Bằng',
  'Cần Thơ',
  'Đà Nẵng',
  'Đắk Lắk',
  'Đắk Nông',
  'Điện Biên',
  'Đồng Nai',
  'Đồng Tháp',
  'Gia Lai',
  'Hà Giang',
  'Hà Nam',
  'Hà Nội',
  'Hà Tĩnh',
  'Hải Dương',
  'Hải Phòng',
  'Hậu Giang',
  'Hoà Bình',
  'Hồ Chí Minh',
  'Hưng Yên',
  'Khánh Hòa',
  'Kiên Giang',
  'Kon Tum',
  'Lai Châu',
  'Lạng Sơn',
  'Lào Cai',
  'Lâm Đồng',
  'Long An',
  'Nam Định',
  'Nghệ An',
  'Ninh Bình',
  'Ninh Thuận',
  'Phú Thọ',
  'Phú Yên',
  'Quảng Bình',
  'Quảng Nam',
  'Quảng Ngãi',
  'Quảng Ninh',
  'Quảng Trị',
  'Sóc Trăng',
  'Sơn La',
  'Tây Ninh',
  'Thái Bình',
  'Thái Nguyên',
  'Thanh Hóa',
  'Thừa Thiên Huế',
  'Tiền Giang',
  'Trà Vinh',
  'Tuyên Quang',
  'Vĩnh Long',
  'Vĩnh Phúc',
  'Yên Bái',
]
